import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: ".js-article-inline-download-wrap",
    ui: {
        downloadPromoWrap: ".js-download-promo-wrap",
        pardotFormWrap: ".js-pardot-form-wrap",
        downloadBtn: ".js-btn-article-inline-download",
        pardotForm: ".js-pardot-form",
    }
})

export default class ViewController extends Marionette.View<Backbone.Model>{

    constructor() {
        super();
    }

    // --------------------------------
    // events
    // --------------------------------

    @on("click @ui.downloadBtn")
    onDownloadBtnClick(JQueryEventObject: any) {
        this.ui.downloadPromoWrap.hide();
        this.showIframe();
    }

    // --------------------------------
    // functions
    // --------------------------------

    onRender() {
        console.log("article inline download viewcontroller rendered");
    }

    showIframe() {
        // must do the following rather than `display: none` so that iframeResizer
        // can initialize size of iFrame, even though it's not shown until click.
        this.ui.pardotFormWrap.css({
            "visibility": "visible",
            "opacity": "1",
            "position": "relative",
        });
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/article-inline-download-module/controller.ts